import { FC } from 'react'
import {
  TopicSentiment,
  sentimentFractions,
} from 'src/interfaces/topics.interface'
import styles from './sentimentBar.module.scss'

interface SentimentBarProps {
  className?: string
  // 0–1. How much of the track this topic fills, relative to the largest topic
  // on show.
  fill: number
  // One continuous bar (no gaps, no pill per segment), as the Content Analysis
  // Overview design draws it.
  flat?: boolean
  sentiment: TopicSentiment
}

export const SentimentBar: FC<SentimentBarProps> = ({
  className,
  fill,
  flat = false,
  sentiment,
}) => {
  const fractions = sentimentFractions(sentiment)
  const filled = Math.max(0, Math.min(1, fill))

  // Each segment is a share of the FILLED part, not of the whole track.
  const segments = [
    { key: 'positive', width: fractions.positive * filled },
    { key: 'neutral', width: fractions.neutral * filled },
    { key: 'negative', width: fractions.negative * filled },
  ].filter(
    // A zero-width segment still costs a flex gap, which shows up as a stray
    // sliver of track between the colours. Drop it entirely.
    (segment) => segment.width > 0
  )

  return (
    <div
      className={`${styles.track} ${flat ? styles.flat : ''} ${
        className ?? ''
      }`}
    >
      {segments.map((segment) => (
        <span
          className={`${styles.segment} ${styles[segment.key]}`}
          key={segment.key}
          style={{ width: `${segment.width * 100}%` }}
        />
      ))}
    </div>
  )
}
